import { Release } from '../../models/release';

/**
 * Ordering rules shared by every surface that lists releases, so the releases page
 * and the header switcher can't drift apart on what "first" means.
 */

/** A release starts on its admin-configured open date, or when it was created if unset. */
export function releaseStartDate(r: Release): string {
  return r.openOnUtc ?? r.createdOnUtc;
}

/**
 * Every active release, earliest start date first. More than one release can be
 * active at a time, so callers must never assume a single one.
 */
export function activeReleasesByStart(releases: Release[]): Release[] {
  return releases
    .filter((r) => r.isActive)
    .sort((a, b) => +new Date(releaseStartDate(a)) - +new Date(releaseStartDate(b)));
}
